export const AlarmCustomIcon = ({ width = 15, height = 15, className = '', ...props }) => {
    return (
        <svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_861_2650)'>
                <path d='M7.49979 14.9643C10.7544 14.9643 13.3926 12.326 13.3926 9.07145C13.3926 5.81691 10.7544 3.17859 7.49979 3.17859C4.24525 3.17859 1.60693 5.81691 1.60693 9.07145C1.60693 12.326 4.24525 14.9643 7.49979 14.9643Z' stroke='#DF0002' strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M0.535645 3.17862C1.28809 2.30461 2.19635 1.578 3.21422 1.03577' stroke='#DF0002' strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M14.4642 3.17862C13.7118 2.30461 12.8035 1.578 11.7856 1.03577' stroke='#DF0002' strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M7.5 5.85718V9.07146H10.1786' stroke='#DF0002' strokeWidth='1.07143' strokeLinecap='round' strokeLinejoin='round' />
            </g>
            <defs>
                <clipPath id='clip0_861_2650'>
                    <rect width='15' height='15' fill='white' transform='translate(0 0.5)' />
                </clipPath>
            </defs>
        </svg>
    );
};
